import { IconButton } from '@atlaskit/button/new';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { Inline, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import React, { useCallback } from 'react';
const wrapperStyles = xcss({
  marginRight: 'space.025',
  textAlign: 'center',
  width: 'size.400',
  height: 'size.200'
});
const ClearSearchIcon = () => /*#__PURE__*/React.createElement(CrossCircleIcon, {
  size: "small",
  primaryColor: "var(--ds-icon)"
  // Empty label here as the label is handled by the parent IconButton component
  ,
  label: ""
});
/**
 * Replaces the default Dropdown Indicator component in React Select.
 * When there is a search input value, it shows a Clear icon, which clears the search input text when clicked.
 * Otherwise, it displays a search icon.
 *
 *  Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomDropdownIndicator` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomDropdownIndicatorInternal = _ref => {
  let {
    searchInputValue,
    testIdPrefix,
    onClearSearchButtonClick
  } = _ref;
  const handleClick = useCallback(event => {
    event.preventDefault();
    onClearSearchButtonClick();
  }, [onClearSearchButtonClick]);
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: wrapperStyles,
    alignBlock: "center",
    alignInline: "center"
  }, searchInputValue ? /*#__PURE__*/React.createElement(IconButton, {
    label: "Clear search text",
    icon: ClearSearchIcon,
    shape: "circle",
    appearance: "subtle",
    spacing: "compact",
    testId: "".concat(testIdPrefix, ".clear-search-text-button"),
    onClick: handleClick
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    size: "small",
    label: ""
  }));
};
export const CustomDropdownIndicator = props => {
  const {
    inputValue,
    onInputChange
  } = props.selectProps;
  const handleClick = useCallback(() => {
    onInputChange('', {
      action: 'input-change',
      prevInputValue: inputValue
    });
  }, [inputValue, onInputChange]);
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(CustomDropdownIndicatorInternal, {
    searchInputValue: props.selectProps.inputValue,
    testIdPrefix: props.selectProps.testId,
    onClearSearchButtonClick: handleClick
  }));
};